import "./App.css";
import Home from "./Screens/Home";
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import PortalLayout from "./layouts/PortalLayout";
import Employees from "./Screens/Employees/Employees";
import EmployeesAddEdit from "./Screens/Employees/EmployeesAddEdit";
import Login from "./Screens/Login/Login";
import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import TopUsers from "./Screens/TopUsers/TopUsers";
import UserDetails from "./Screens/UserDetails/UserDetails";
import Subscription from "./Screens/Subscription/Subscription";
import Notification from "./Screens/Notification/Notification";
import ChatSupport from "./Screens/Profiles/Profiles";
import Profiles from "./Screens/Profiles/Profiles";
import Registration from "./Screens/Registration/Registration";
import Chats from "./Screens/Chat/Chat";
import ForgotPassword from "./Screens/ForgotPassword/ForgotPassword";
import Blogs from "./Screens/blogs/Blogs";
import UserProfiles from "./Screens/UserProfiles/UserProfiles";
import AppVersion from "./Screens/AppVersion/AppVersion";
import MatchUsers from "./Screens/MatchUser/MatchUser";
import AdminPanelUsers from "./Screens/AdminPanelUsers/AdminPanelUsers";
import DummyUsers from "./Screens/DummyUsers/DummyUsers";
import BoostHistory from "./Screens/BoostHistory/BoostHistory";
import ReferralProgram from "./Screens/ReferralProgram/ReferralProgram";
import PromotionalMessage from "./Screens/PromotionalMessage/PromotionalMessage";
import ManualPurchase from "./Screens/ManualPurchase/ManualPurchase";
import CsrManualSubscription from "./Screens/CsrManualSubscription/CsrManualSubscription";
import Ads from "./Screens/Ads/Ads";
import ContentReports from "./Screens/ContentReports/ContentReports";
import BannedUsers from "./Screens/BannedUsers/BannedUsers";
import Support from "./Screens/Support/Support";
import SupportTeamsPage from "./Screens/SupportTeams/SupportTeamsPage";
import SalesCrmPage from "./Screens/SalesCrm/SalesCrmPage";
import CsrOutreachPage from "./Screens/CsrOutreach/CsrOutreachPage";
import ChatSupportLogPage from "./Screens/ChatSupportLog/ChatSupportLogPage";
import ChatSupportActivityPage from "./Screens/ChatSupportLog/ChatSupportActivityPage";
import ApprovalsPage from "./Screens/Approvals/ApprovalsPage";
import NasePricesPage from "./Screens/NasePrices/NasePricesPage";
import AgentReportsPage from "./Screens/AgentReports/AgentReportsPage";
import SaleAgentPage from "./Screens/SaleAgent/SaleAgentPage";
function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  // useEffect(() => {
  //   if (!isAuthenticated) {
  //     navigate("/login");
  //   }
  // }, [isAuthenticated]);

  useEffect(() => {
    setIsAuthenticated(localStorage.getItem("naseebiAdmin"));
  }, [location.pathname]);

  return (
    <PortalLayout>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Home />} />
        <Route path="/users" element={<Employees />} />
        <Route path="/topusers" element={<TopUsers />} />
        <Route path="/user-profiles" element={<UserProfiles />} />
        <Route path="/content-reports" element={<ContentReports />} />
        <Route path="/community-banned-users" element={<BannedUsers />} />
        <Route path="/userdetails/:id" element={<UserDetails />} />
        <Route path="/subscription" element={<Subscription />} />
        <Route path="/manual-purchase" element={<ManualPurchase />} />
        <Route path="/csr-manual-subscription" element={<CsrManualSubscription />} />
        <Route path="/ads" element={<Ads />} />
        <Route path="/notifications" element={<Notification />} />
        <Route path="/promotional-messages" element={<PromotionalMessage />} />
        <Route path="/profiles" element={<Profiles />} />
        <Route path="/registration" element={<Registration />} />
        <Route path="/chats" element={<Chats />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/app-version" element={<AppVersion />} />
        <Route path="/match-user" element={<MatchUsers />} />
        <Route path="/admin-panel-users" element={<AdminPanelUsers />} />
        <Route path="/dummy-users" element={<DummyUsers />} />
        <Route path="/boost-history" element={<BoostHistory />} />
        <Route path="/referrals" element={<ReferralProgram />} />
        <Route path="/support" element={<Support />} />
        <Route path="/support-teams" element={<SupportTeamsPage />} />
        <Route path="/sales-crm" element={<SalesCrmPage />} />
        <Route path="/csr-outreach" element={<CsrOutreachPage />} />
        <Route path="/sale-agent" element={<SaleAgentPage />} />
        <Route path="/chat-support-log" element={<ChatSupportLogPage />} />
        <Route path="/chat-support-activity" element={<ChatSupportActivityPage />} />
        <Route path="/approvals" element={<ApprovalsPage />} />
        <Route path="/nase-prices" element={<NasePricesPage />} />
        <Route path="/agent-reports" element={<AgentReportsPage />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        {/*<Route path="users/add" element={<EmployeesAddEdit />} />*/}
        {/*<Route path="users/edit" element={<EmployeesAddEdit edit={true} />} />*/}
      </Routes>
    </PortalLayout>
  );
}

export default App;
